import type { LinkParts } from "@/shared/lib/referralLink";

interface LinkPreviewProps {
  parts: LinkParts;
}

/** Подсветка частей ссылки: партнёру видно, где путь, где query, а где атрибуция после #. */
export function LinkPreview({ parts }: LinkPreviewProps) {
  return (
    <pre className="max-h-52 overflow-auto rounded-input bg-canvas p-3 font-mono text-xs leading-relaxed whitespace-pre-wrap break-all">
      <span className="text-input-text">{parts.base}</span>
      {parts.query.map(([name, value], index) => (
        <span key={name}>
          <span className="text-label-text">{`${index === 0 ? "?" : "&"}${name}=`}</span>
          <span className="text-brand">{value}</span>
        </span>
      ))}
      <span className="text-error-accent">#</span>
      {parts.hash.map(([name, value], index) => (
        <span key={name}>
          <span className="text-label-text">{`${index === 0 ? "" : "&"}${name}=`}</span>
          <span className="text-brand">{value}</span>
        </span>
      ))}
    </pre>
  );
}
